module.exports = __webpack_public_path__ + "static/fonts/Inter_24pt-Medium.4591e900.ttf";